import axios from 'axios';

const API_BASE = 'https://backup.navia.co.in/api';

// ─── Client API ───────────────────────────────────────────────────────────────
const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('nb_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('nb_token');
      localStorage.removeItem('nb_client');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const initiateLogin    = (ucc, dob)       => api.post('/auth/login/initiate', { ucc, dob });
export const verifyOTP        = (sessionId, otp) => api.post('/auth/login/verify-otp', { sessionId, otp });
export const getPositions     = ()               => api.get('/positions');
export const placeSquareOff   = (data)           => api.post('/orders/squareoff', data);
export const getMyOrders      = ()               => api.get('/orders/my-orders');
export const getHoldings      = ()               => api.get('/holdings');
export const getDayPositions  = ()               => api.get('/dropcopy/positions');
// ── Added: B/F positions for Dashboard net position merge ──────────────────
export const getBFPositions   = ()               => api.get('/bf/positions');

// ─── Admin API ────────────────────────────────────────────────────────────────
const adminApi = axios.create({ baseURL: API_BASE });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('nb_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('nb_admin_token');
      localStorage.removeItem('nb_admin');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const adminInitiateLogin  = (username)              => adminApi.post('/admin/auth/login/initiate', { username });
export const adminRetriggerOTP    = (username)              => adminApi.post('/admin/auth/login/initiate', { username, force: true });
export const adminVerifyOTP      = (sessionId, otp)        => adminApi.post('/admin/auth/login/verify-otp', { sessionId, otp });
export const getSegments         = ()                      => adminApi.get('/admin/control/segments');
export const toggleSegment       = (exchange, segment, enable, notes) =>
  adminApi.post('/admin/control/segments/toggle', { exchange, segment, enable, notes });
export const sendCommunication   = (data)                  => adminApi.post('/admin/control/communicate', data);
export const getCommunications   = ()                      => adminApi.get('/admin/control/communications');
export const getAdminOrders      = (params)                => adminApi.get('/admin/orders', { params });
export const updateOrderStatus   = (data)                  => adminApi.post('/admin/orders/update-status', data);
export const generateOrderFile   = (order_ids, exchange)   =>
  adminApi.post('/admin/orders/generate-file', { order_ids, exchange }, { responseType: 'blob' });
export const getOrderStats       = ()                      => adminApi.get('/admin/orders/stats');

export const uploadBFFile = (formData, onProgress) =>
  adminApi.post('/bf/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
    onUploadProgress: onProgress
  });
export const getBFUploadStatus  = () => adminApi.get('/bf/status');
export const getBFUploadHistory = () => adminApi.get('/bf/history');

// ─── Dealer API ───────────────────────────────────────────────────────────────
const dealerApi = axios.create({ baseURL: API_BASE });

dealerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('nb_dealer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

dealerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('nb_dealer_token');
      localStorage.removeItem('nb_dealer');
      window.location.href = '/dealer/login';
    }
    return Promise.reject(error);
  }
);

export const dealerInitiateLogin = (dealer_id)      => dealerApi.post('/dealer/login/initiate', { dealer_id });
export const dealerVerifyOTP     = (sessionId, otp) => dealerApi.post('/dealer/login/verify-otp', { sessionId, otp });
export const generateSSOToken    = (ucc)            => dealerApi.post('/dealer/sso/generate', { ucc });
export const validateSSOToken    = (token)          => api.post('/dealer/sso/validate', { token });
export const getDealerLogs       = ()               => dealerApi.get('/dealer/logs');

export { adminApi };
export default api;